import React, { useEffect } from 'react';
import { Grid, Box, makeStyles, Hidden } from '@material-ui/core';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/busnew.svg';
import '../home.css';
import './Bus.css';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import ima from '../../assets/images/home-bg-1.jpg';
import { useDispatch } from 'react-redux';
import TitleText from '../../components/reusableComponents/TitleText';
import { useHistory } from 'react-router-dom';
import SearchBus from '../../form/SearchBus';
import Typed from 'typed.js';
import SearchBus2 from '../../form/SearchBus2';
const useStyles = makeStyles((theme) => ({
	back: {
		backgroundImage: `url(${ima})`,
		height: 1189,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '1px -323px',
		position: 'relative',
		[theme.breakpoints.up('lg')]: {
			height: 494,
		},
		[theme.breakpoints.down('xs')]: {
			height: 1144,
		},
	},
}));
function BusPage() {
	const handleTheme = () => {
		let themeBtn = document.querySelector('#theme-btn');
		themeBtn.classList.toggle('fa-sun');

		if (themeBtn.classList.contains('fa-sun')) {
			document.body.classList.add('active');
		} else {
			document.body.classList.remove('active');
		}
	};
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const el = React.useRef(null);
	// Create reference to store the Typed instance itself
	const typed = React.useRef(null);
	React.useEffect(() => {
		const options = {
			strings: ['Welcome to <strong>Musafirbazar</strong>', 'Book Bus Tickets'],
			typeSpeed: 100,
			backSpeed: 100,
			loop: true,
		};

		// elRef refers to the <span> rendered below
		typed.current = new Typed(el.current, options);

		// return () => {
		// 	// Make sure to destroy Typed instance during cleanup
		// 	// to prevent memory leaks
		// 	typed.current.destroy();
		// };
	}, []);
	useEffect(() => {
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
	}, []);

	return (
		<>
			{/* <!-- header section starts  --> */}

			<header className='header'>
				<a href='#' className='logo'>
					<img src={musafirbazarlogo} width='200px' height='50px'></img>
				</a>
				<Hidden only={['xs']}>
					<Box display='flex'>
						<Box
							display='flex'
							alignItems='center'
							onClick={() => history.push('/home')}>
							<img src={flightnew}></img>
							<TitleText four>Flights</TitleText>
						</Box>
						<Box
							display='flex'
							alignItems='center'
							ml={'30px'}
							onClick={() => history.push('/new')}>
							<img src={trainnew}></img>
							<TitleText four>Trains</TitleText>
						</Box>
						<Box display='flex' alignItems='center' ml={'30px'}>
							<img
								src={busnew}
								style={{
									filter:
										' invert(46%) sepia(45%) saturate(4226%) hue-rotate(348deg) brightness(96%) contrast(91%)',
								}}></img>
							<TitleText four textStyle={{ color: '#EC5B25' }}>
								Buses
							</TitleText>
						</Box>
						<Box display='flex' alignItems='center' ml={'30px'}>
							<img src={hotelnew}></img>
							<TitleText four>Hotels</TitleText>
						</Box>
					</Box>
				</Hidden>

				<div className='icons'>
					{/* <div className='fas fa-search' id='search-btn'></div> */}
					<div
						className='fas fa-moon'
						id='theme-btn'
						onClick={handleTheme}></div>
					<div
						className='fas fa-user'
						id='login-btn'
						onClick={() => history.push('/agent')}></div>
					<div className='fas fa-bars' id='menu-btn'></div>
				</div>

				<nav className='navbar'>
					<a href='#home'>home</a>
					<a href='#packages'>packages</a>
					<a href='#services'>services</a>
					<a href='#pricing'>pricing</a>
					<a href='#review'>review</a>
					<a href='#contact'>contact</a>
					<a href='#blogs'>blogs</a>
				</nav>

				{/* <form action='' className='login-form'>
					<div className='inputBox'>
						<span>username</span>
						<input type='text' placeholder='enter your name' />
					</div>

					<div className='inputBox'>
						<span>password</span>
						<input type='password' placeholder='enter your password' />
					</div>

					<div className='remember'>
						<input type='checkbox' name='' id='login-remember' />
						<label for='login-remember'>remember me</label>
					</div>

					<input type='submit' className='btn' value='login' />
				</form> */}
			</header>
			<section
				// className='form-container'
				style={{
					backgroundImage: `url(${ima})`,
					height: 1189,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: '-440px -80px',
					position: 'relative',
				}}
				data-aos='zoom-in'>
				<Grid container>
					<Grid item xs={12} sm={1}></Grid>
					<Grid item xs={12} sm={11}>
						<p
							ref={el}
							style={{
								textAlign: 'center',
								marginTop: '25rem',
								fontSize: '45px',
								color: 'darkred',
								// marginBottom: '35px',
							}}></p>
						<div className='header-form'>
							<SearchBus2 />
						</div>
					</Grid>
				</Grid>
				{/* <SearchForm /> */}

				{/* <SearchFlight /> */}
			</section>
			<section className='services' id='services'>
				<h1 className='heading'>
					{' '}
					our <span>Commitment</span>{' '}
				</h1>

				<div className='box-container'>
					<div className='box' data-aos='zoom-in'>
						<span>01</span>
						<i class='fa fa-plus' aria-hidden='true'></i>
						<h3>safety</h3>
						<p>
							Assured safety with features including well-sanitized buses, panic
							button, GPS tracking, CCTV cameras, ABS & Vehicle Rollover
							protection.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>02</span>
						<i className='fas fa-bus'></i>
						<h3>Comfort</h3>
						<p>
							Unparalleled comfort including noiseless cabins, ultra-wide
							Maharaja seats with up to 140 degrees recline, extra legroom, and
							calf support.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>03</span>
						<i className='fas fa-laptop	'></i>
						<h3>Convenience</h3>
						<p>
							Hassle-free and seamless digital booking, boarding, luggage
							tagging along with clean waiting lounges, and pre-defined hygienic
							pit stops.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>04</span>
						<i className='fas fa-globe'></i>
						<h3>Consistency</h3>
						<p>
							Our promise is to deliver the same service every time and all the
							time, we are mad about your experience with us.
						</p>
					</div>
				</div>
			</section>
			<section className='services' id='services'>
				<h1 className='heading'>
					{' '}
					We <span>Promise</span> To <span>Deliver</span>
				</h1>

				<div className='box-container'>
					<div className='box' data-aos='zoom-in'>
						<span>01</span>
						<i class='fa fa-plus' aria-hidden='true'></i>
						<h3>safety+</h3>
						<p>
							With Safety+ we have brought in a set of measures like Sanitized
							buses, mandatory masks etc. to ensure you travel safely
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>02</span>
						<i className='fas fa-headset'></i>
						<h3>Superior Customer Service</h3>
						<p>
							We put our experience and relationships to good use and are
							available to solve your travel issues.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>03</span>
						<i className='fas fa-rupee-sign	'></i>
						<h3>Lowest Prices</h3>
						<p>
							We always give you the lowest price with the best partner offers.
						</p>
					</div>

					<div className='box' data-aos='zoom-in'>
						<span>04</span>
						<i className='fas fa-solid fa-gift'></i>
						<h3>Unmatched Benifits </h3>
						<p>
							We take care of your travel beyond ticketing by providing you with
							innovative and unique benefits.
						</p>
					</div>
				</div>
			</section>
			<section className='footer'>
				<div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>our branches</h3>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i> india{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i> russia{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i> japan{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i> france{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i> canada{' '}
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>quick links</h3>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> home{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> packages{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> services{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> pricing{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> review{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> contact{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-chevron-right'></i> blogs{' '}
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>contact info</h3>
						<a href='#'>
							{' '}
							<i className='fas fa-phone'></i> +91 887-777-3388{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-envelop'></i> sales@musafirbazar.com{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fas fa-map-marker-alt'></i>1st Floor,New Tech Grand,
							Bank More, Dhanbad-826001
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>follow us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							{' '}
							<i className='fab fa-facebook-f'></i> facebook{' '}
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							{' '}
							<i className='fab fa-twitter'></i> twitter{' '}
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							{' '}
							<i className='fab fa-instagram'></i> instagram{' '}
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							{' '}
							<i className='fab fa-linkedin'></i> linkedin{' '}
						</a>
						<a href='#'>
							{' '}
							<i className='fab fa-pinterest'></i> pinterest{' '}
						</a>
					</div>
				</div>

				<div className='credit'> © Copyright 2015 - 2022 Musafir Bazar</div>
			</section>
		</>
	);
}

export default BusPage;
